<template>
  <span>
    <img draggable="false" class="clickable" id="quit_btn_top" @click="goToStart()" src="./../../assets/images/Asset 58.png" alt="">
    <img draggable="false" class="background_image" src="./../../assets/images/eid/Asset 50.png" alt="">
    
    <span v-show="selected_text == -1">
      <img draggable="false" id="eid_logo" src="./../../assets/images/eid/Asset 48.png">
      <img draggable="false" id="people" src="./../../assets/images/eid/Asset 49.png">
      <img draggable="false" class="clickable" id="eid_play_btn" @click="showText()" src="./../../assets/images/Asset 57.png" alt="">
    </span>

    <span v-show="selected_text >= 0">
      <span v-if="selected_text == 0" id="eid_game_text">Eid-al-Fitr (Bodo-Kupat)</span>
      <span v-html="texts[selected_text]" id="marron_game_intro_text" :style="selected_text > 0 ? 'margin-top: 7%;' : ''"></span>
      <img draggable="false" class="clickable" v-show="texts.length > (selected_text + 1)" @click="nextText()" id="next_btn" src="./../../assets/images/Asset 51.png" alt="">
      <img draggable="false" class="clickable" v-show="selected_text > 0" @click="prevText()" id="prev_btn" src="./../../assets/images/Asset 51.png" alt="">
    </span>
    
  </span>
</template>

<script>


export default {
  name: "EidStart",
  mounted() {},

  created() {},
  destroyed() {},

  data() {
    return {
      selected_text: -1,
      texts: [
        "De Ramadan wordt afgesloten met een driedaags feest, de zogeheten Eid-al-Fitr, in het Nederlands ook wel bekend als het Suikerfeest. <br><br> De eerste ochtend van Eid-al-Fitr bezoeken mannen en vrouwen de moskee voor het gezamenlijke speciale gebed voor deze feestdag. Iedereen gaat mee. Voordat het gebed begint, dien je als moslim eerst de 'zakat' (aalmoes) te hebben voldaan. De hoogte van deze 'zakat' is afhankelijk van de voedselprijzen. (ongeveer 1 maaltijd)",

        "De rest van de dag gaat men zo veel mogelijk bij familie op bezoek. Ter gelegenheid van Eid-al-Fitr worden zoete gerechten en lekkernijen gegeten en geeft men elkaar en de armen cadeautjes. Zowel de mannen als de vrouwen trekken meestal nieuwe kleren aan en het huis wordt extra netjes gemaakt voor deze feestdag. Daarna gaan de mensen naar de ontmoetingsplaats, een moskee of een zaal of een stuk open terrein, om daar naar de preek van de imam te luisteren, waarmee de Ramadan echt afgesloten wordt. Ook de vrouwen en kinderen zijn daarbij meestal aanwezig, zoals de profeet Mohamed heeft aanbevolen. Dan omhelzen de mensen elkaar, en vergeven zij elkaar eventuele fouten uit het afgelopen jaar. Ze wensen elkaar een gezegend feest.",

        "Minderbedeelden krijgen vaak voedsel en soms kleding van de rijkere, ook is het een plicht om voor de armen te zorgen. In Suriname staat het Eid-al-Fitr feest ook bekend onder de naam Bodo. De volledige naam is Bodo Kupat. Deze naam is meer bekend onder de Javanen die het Islam geloof belijden. <br><br> De Javaans Islamitische beweging in Suriname kent afhankelijk van de gebedsrichting Oost- en Westbidders.",

        "De eerste contractanten uit Java richtte zich in Suriname tot het westen, daar zij in Indonesië gewend waren zich naar Mekka te richten dat voor hen in de westelijke richting was. De groepen na hen, hebben hun gebedsrichting aangepast naar het oosten- Mekka ligt vanuit Suriname gezien in het oosten. Het verschil tussen de twee stromingen ligt ook nog in de culturele en religieuze beleving, waarbij de Westbidders meer gebruiken kennen uit de oeroude Javaanse religie Kedjawen."
      ]
    };
  },

  methods: {
    goToStart() {
      this.$router.push('/start');
    },

    showText() {
      this.selected_text = 0
    },

    nextText() {
      this.selected_text++;
    },

    prevText() {
      this.selected_text--;
    },
  },

  computed: {}
};
</script>

<style>
  #eid_game_text {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 4%;
    width: 50%;
    left: 25%;
    color: white;
    font-size: 4vw;
    text-align: center;
    filter: drop-shadow(5px 5px 5px #3d3d3d);
    -webkit-filter: drop-shadow(5px 5px 5px #3d3d3d);
  }
  #eid_play_btn {
    position: absolute;
    margin-top: 22%;
    left: 44%;
    width: 15%;
  }
  #eid_logo {
    position: absolute;
    margin-top: 5%;
    left: 28%;
    width: 45%;
  }
  #people {
    position: absolute;
    margin-top: 19.4%;
    left: 18.5%;
    width: 62%;
  }
</style>


